import React , { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedHTMLMessage } from 'react-intl';


import SeriesTable from '../SeriesTable';

import {requireUrlsFn, buildUrls, generateConfiguration} from '../../library/GraphFunctions';

import * as i18n from '../../i18n/';

import { buildDrillDownPath, calculateDrilldown, buildDrillDownList} from './Utils';

import { getDrilldownLabel } from './Utils';

import { lockChartsData, unlockChartsData } from '../../actions'

import * as ActionConstants from '../../constants/';

import Chart from '../Chart';

import ToggleDisplay from '../ToggleDisplay';


import { urlsConfiguration } from '../../library/';

import { saveAs } from 'file-saver';


import { convertToArray, convertMessage, addTimeSeries, getMessage } from '../../utils';

import Toolbar from './Toolbar';

import Helpable from '../Helpable';

const Highcharts = window.Highcharts;

class ErrorInfo extends Component {

    render() {
        let msg = this.props.error;
        let messaggio = msg.message || msg.error;
        return (
            <div className="alert alert-danger" >
                <span className="pficon pficon-error-circle-o" />
                <strong> Error {messaggio}</strong>
            </div>
        )
    }
}


class BoxError extends Component {

    render() {
        //console.log("BoxError: hasError " + this.props.hasError);

        let errorInfo = null;
        if (this.props.hasError) {
            errorInfo = [];

            this.props.errors.forEach(function(error,i) {
                //console.dir(error.message);
                errorInfo.push (
                    <ErrorInfo key={i} error={error} />);
            });
        }
        return (
            <div style={{marginTop:'10px'}}>
                {errorInfo}
            </div>
        )
    }
}

class BoxNoError extends Component {

    render() {
        let res = <div></div>;
        if (!this.props.hasError)
            res = <div>{this.props.children}</div>;
        return (<div>{res}</div>);
    }
}


// BoxBody visualizza informazioni relative al grafico e al
class BoxBody extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showInfo:false
        }
        //  this.toolbarShowInfoHandler=this.toolbarShowInfoHandler.bind(this);
    }

    render() {
        const {formatMessage} = this.props.intl;

        let loadingStyle = {
            textAlign: 'center',
            fontSize: '10pt',
            fontWeight:'400',
            paddingTop: '0px',
            marginTop: '15px'
            //color: '#1f88d5'
        };

        let imgStyle = {
            height:'50px',
            width:'50px'
        };

        // Loading spinner
        var loadingInfo = (
            <div style={loadingStyle}>
                <img style={imgStyle} role="presentation" src={require('../../resources/images/spinner.svg')}/>
                <div >{formatMessage({id:'loadingChart'})}</div>
            </div>
        );

        let cardBodyStyle = {
            marginTop:'5px'
        };


        return (
            <div className="card-pf-body" style={cardBodyStyle}>
                {this.props.isLoading?loadingInfo:
                    <div>
                        <Toolbar toggleDetailsInfo={this.props.toggleDetailsInfo}
                                 renderHistoryPath={true}
                                 exportHandler={this.props.exportHandler}
                                 resetFiltersHandler={this.props.resetFiltersHandler}
                                 paramContext={this.props.paramContext}
                                 currentDrillDown={this.props.currentDrillDown}
                                 routeParams={this.props.routeParams}
                                 location={this.props.location}
                                 description={{description: this.props.description, title: this.props.title}} //handleActionClick={this.props.handleActionClick}
                                 context={this.props.context}
                                 filtersList={this.props.optionsList}
                                 hasData={this.props.hasData}/>

                        <div className="row">
                            <div className="col-md-12">

                                <div>


                                    <BoxNoError hasError={(this.state.errors && this.state.errors.length>0) }>
                                        {this.props.children}
                                    </BoxNoError>
                                </div>

                            </div>

                            <ToggleDisplay show={this.props.toggleDetailsInfo.show}>
                                <div className="col-sm-12" style={{marginTop:'10px'}}>
                                    {this.props.toggleDetailsInfo.dataTable}
                                </div>
                            </ToggleDisplay>

                        </div>
                    </div>
                }

            </div>


        );
    }
}

class ChartPanel extends Component {

    constructor(props) {
        super(props);

        this.drillDownHandler=this.drillDownHandler.bind(this);
        this.collectsData=this.collectsData.bind(this);
        this.requireChartsData=this.requireChartsData.bind(this);
        this.toggleDetailsHandler=this.toggleDetailsHandler.bind(this);
        this.exportHandler=this.exportHandler.bind(this);
        this.resetFiltersHandler=this.resetFiltersHandler.bind(this);
        try {


            if (this.props.errors && this.props.errors.length>0) throw new Error(this.props.errors[0].error);

            this.requireChartsData(this.props.routeParams, this.props.paramContext, this.props.queryParams);

            this.state = {
                showGuide:false,
                hideGraph: false,
                renderHistoryPath: true,
                minimize: false,
                details: false,
                leftActive: true,
                rightActive:false,
                isLoading:true,
                currentDrillDown:0,
                errors:this.props.errors,
                config:{
                    config: {},
                    context:{}
                }
            };
        } catch (err) {

            this.state = {
                renderHistoryPath: false,
                isLoading: false,
                errors: [{error:err.message}],
                config:{
                    config: {},
                    context:{}
                }
            }
        }
    }


    exportHandler(event) {


        const { formatMessage } = this.props.intl;

        const {params} = this.props.routeParams;

        let date = null;
        let fileName=formatMessage({id:'allYears'});


        if ( params.year ) {
            date = (new Date(params.year, params.month ? (params.month-1) : 0, params.day ? params.day : 1)).getTime();
            fileName=params.year+(params.month?'-'+params.month:'')+(params.day?'-'+params.day:'');
        }

        let formattedDate  = getDrilldownLabel(this.state.currentDrillDown,date, this.props.intl);

        let query =this.props.location.query;
        let filters ="";

        if (query && Object.keys(query).length !== 0) {
            filters = "[";
            Object.keys(query).forEach(function(k,i) {
                if (i>0) filters+=","
                filters+=k+'='+formatMessage({id:k+'.'+query[k]});
            });
            filters += "]";
        }

        switch(event.action) {

            case "panel.action.export.png": {

                let chart = this.refs['outerChartRef'].refs.wrappedInstance;

                fileName = this.props.title+"-"+fileName;

                chart.export(this.props.title, formattedDate+"\n"+filters, 'image/png', fileName, event.sizeOption);

                chart.resetTitle();

            }
                break;
            case "panel.action.export.svg": {

                let chart = this.refs['outerChartRef'].getWrappedInstance();

                //let fileName = 'chart_'+ this.props.title+"-"+formattedDate;
                fileName = this.props.title+'-'+fileName+'.svg';

                chart.export(this.props.title, formattedDate, 'image/svg+xml', fileName, event.sizeOption);
                chart.resetTitle();
            }
                break;

            case "panel.action.export.csv": {

                let csvStringArray = [];
                let csvString = "";
                let seriesAsArray = addTimeSeries(this.state.series);
                convertToArray(this.state.series, seriesAsArray);
                const num = seriesAsArray[0].length;

                // Header
                var context = this.props.paramContext;

                var paths = urlsConfiguration[context.kind].operations[context.operation].paths;


                csvStringArray.push(formattedDate);

                let fullEnabled=[];
                let filled = 1;
                fullEnabled.push(true);
                if (paths[0] ) {
                    filled++;
                    fullEnabled.push(true)
                }
                if (paths[1] && (paths[0].merge && paths[1].merge) ) {

                    fullEnabled.push(false);
                } else {
                    fullEnabled.push(true);
                }
                filled++;
                for (let i=filled; i<num; i++) {
                    fullEnabled.push(true);
                }

                this.state.series.forEach(function( serie, serieIndex ) {
                    serie.rows.forEach(function( row, rowIndex ) {

                        if (fullEnabled[serieIndex+1]) {
                            csvStringArray.push(getMessage(row.key, paths, serieIndex, this.props.intl));
                        }
                    }.bind(this))
                }.bind(this));

                csvStringArray.forEach((csv, idx) => {
                        csvString += csv + ',';
                });


                // Data

                seriesAsArray.forEach(function(row,i) {
                    csvString+="\n";

                    row.forEach(function(col,j) {
                        if (fullEnabled[j]) {
                            var val = convertMessage(col, j, this.state.currentDrillDown, this.props.intl);

                            if (j > 0) csvString += ','
                            csvString += '"' + val + '"';
                        }
                    }.bind(this))

                }.bind(this));

                fileName = this.props.title+'-'+fileName+'.csv';
                let blob = new Blob([csvString], {type:"text/csv"});
                saveAs(blob, fileName);

            }
                break;
            default:
                break;
        }
    }


    // Funzione utilizzata drillDownHandler per gestire history del router
    dateFormatter(date, period) {
        switch (period) {

            case "monthly":
                return Highcharts.dateFormat("%Y", date);


            case "daily":
                return Highcharts.dateFormat("%m", date);


            case "hourly":
                return Highcharts.dateFormat("%d", date);


            default:
                break;

        }
    }

    resetFiltersHandler() {

        // Se resetto i filtri allora il primo valore del filtro sono tutte le zone (italy/strangers).
        let query = {};
        switch(this.props.paramContext.kind) {
            case 'registrar':
                query = {zone:'all'};
                break;
            case 'registrant':
                query = {zone:'all'};
                break;
            default:
                break
        }

        this.context.router.push({pathname:this.props.location.pathname, query:query});
    }


    // Handler che passato a Chart e quindi alla sua impl Highcharts che prende la data passata
    // da Highcharts e costruisce un path utile per il router react
    //

    drillDownHandler(date) {

        let location = this.props.routeParams.location;
        let routerParams = this.props.routeParams.params;

        let ctx = this.props.paramContext;

        let maxDrillDown = urlsConfiguration[ctx.kind].operations[ctx.operation].maxDrillDown;

        let currentDrillDown = calculateDrilldown(routerParams);


        // Calcolo
        if (currentDrillDown < maxDrillDown) {

            //  var period = ActionConstants.DRILLDOWN[currentDrillDown];


            // Bisogna costrire prossima richiesta quindi il drilldown successivo rispetto all'attuale
            let nextPeriod = ActionConstants.DRILLDOWN[currentDrillDown+1];

            // Il router arricchisce le proprietà della componente con attributi
            // contenenti il path visibile nel browser (eccetto il dominio e porta)
            // A questo bisogna aggiungere la parte della data corrispondente al livello
            // di drilldown raggiunto.

            let path = this.dateFormatter(date,nextPeriod);

            let endsWithSlash = location.pathname.indexOf("/", location.pathname.length-1) !== -1;

            if (path) {
                path = (!endsWithSlash?"/":"")+ path;
                // resetHelp();
                this.context.router.push({pathname:this.props.location.pathname+path, query:this.props.location.query});
            }
        }
    }


    // Callback della promise che permette di
    collectsData(key,values) {
        let errors=[];

        if (values) {

            values.forEach(function(value,i){
                if (value && value.error) {
                    errors.push(value);
                }
            });
        }


        let currLocale = this.props.intl.locale || 'it';

        let noErrors = (errors && errors.length===0);
        let hasRowsData = (noErrors && values && values[0] && values[0].rows.length >0);
        let hasColsData = (noErrors && values && values[0] && values[0].cols.length >0);
        let shouldRenderHistoryPath = noErrors &&  hasRowsData && hasColsData ;

        //console.dir(shouldRenderHistoryPath);

        if (noErrors) {
            //let currentDrillDown = 0;

            let routerParams = this.props.routeParams.params;

            let currentDrillDown = calculateDrilldown(routerParams);

            let ctx = this.props.paramContext;

            let maxDrillDown=urlsConfiguration[ctx.kind].operations[ctx.operation].maxDrillDown;

            let config =
                generateConfiguration(
                    values,ActionConstants.DRILLDOWN[currentDrillDown],
                    this.props.paramContext, i18n[currLocale], currentDrillDown, maxDrillDown
                );

            // Unlock Oramai abbiamo ricevuto i dati e calcolato configurazione. Si possono sbloccare i menu
            unlockChartsData();
            this.setState({
                renderHistoryPath: (shouldRenderHistoryPath && ( maxDrillDown >0 )),
                currentDrillDown: currentDrillDown,
                series:values,
                enabled: config.enabled,
                errors:errors,
                config: {
                    config:config,
                    context:this.props.paramContext
                },
                isLoading: false,
            })
        } else {
            this.setState({renderHistoryPath:false, currentDrillDown:0, errors:errors, isLoading:false})
        }
    }


    componentWillReceiveProps(nextProps) {

        try {

            if (nextProps.errors && nextProps.errors.length>0) throw new Error(nextProps.errors[0].error);

            let drilldownState = this.requireChartsData(nextProps.routeParams, nextProps.paramContext, nextProps.queryParams);

            //let routerParams = nextProps.routeParams.params;

            let currentDrillDown = drilldownState.currentDrillDown;

            let ctx = nextProps.paramContext;

            let maxDrillDown = drilldownState.maxDrillDown;

            // Siamo arrivati alla fine della della corsa della profondità
            if (maxDrillDown === currentDrillDown) {

                let config = this.state.config.config;
                if (config && config.plotOptions && config.plotOptions.series)
                    config.plotOptions.series.cursor= 'default';
            }

            this.setState({
                config: {
                    context:ctx,
                    config:nextProps.paramContext
                },
                renderHistoryPath: (maxDrillDown >0),
                hideGraph: false,
                isLoading: true,
                errors:this.props.errors|| [],
                currentDrillDown: currentDrillDown
            });
        } catch (err) {

            // ChartsStore set error
            this.setState({
                renderHistoryPath: false,
                currentDrillDown:0,
                isLoading: false,
                errors: [{error:err.message}],
                config:{
                    config: {},
                    context:{}
                }
            });
        }

    }






    requireChartsData(routeParams, paramContext, queryParams) {

        let routerParams = routeParams.params;

        let currentDrillDown = calculateDrilldown(routerParams)


        let ctx = paramContext;

        try {
            if (! urlsConfiguration[ctx.kind]) throw new Error("KIND "+ctx.kind);

            if (! urlsConfiguration[ctx.kind].operations[ctx.operation]) throw new Error("OPERATION "+ctx.operation);


            let  maxDrillDown=urlsConfiguration[ctx.kind].operations[ctx.operation].maxDrillDown;



            // Ogni operazione ha un massimo di profondità di navigazione
            if (maxDrillDown >= currentDrillDown) {

                var period = ActionConstants.DRILLDOWN[currentDrillDown];

                let ddArr = buildDrillDownList(period, routerParams.year, routerParams.month, routerParams.day);
                var drillDown = buildDrillDownPath(ddArr);

                var context = Object.assign({}, {context: ctx}, {stack: true});


                var urls = buildUrls(context.context,drillDown, queryParams);
                let key=10;

                requireUrlsFn(key,urls, this.collectsData);

                // Sono stati richiesti i dati fino a che non sono disponibili bisogna bloccare  i menu
                lockChartsData();

                return ({
                    currentDrillDown: currentDrillDown,
                    maxDrillDown: maxDrillDown
                })

            } else {
                throw new Error("MAXDEPTH ");
            }
        } catch (err) {
            //console.log("THROW ERROR")
            //console.dir(err);
            unlockChartsData();
            throw err;
        }
    }


    // Handler del pulsante dei dettagli
    toggleDetailsHandler(evt) {

        var context = this.state.config.context;
        var maxDrillDown = urlsConfiguration[context.kind].operations[context.operation].maxDrillDown;
        this.setState({
            hideGraph: !this.state.hideGraph,
            renderHistoryPath:  (maxDrillDown > 0)
        })
    }


    render() {
        //console.log("RENDER");
        const { formatMessage } = this.props.intl;
        const {params} = this.props.routeParams;


        let descriptionRef = this.props.paramContext.kind+"."+this.props.paramContext.operation+".description";


        let date = null;
        let currDepth = this.state.currentDrillDown;
        if ( params.year ) {
            date = (new Date(params.year, params.month ? (params.month-1) : 0, params.day ? params.day : 1)).getTime();
        }


        var drillDownButtons=null;
        let boxSubtitle;

        let type = this.props.paramContext.type;




        let ctx = this.props.paramContext;
        let dataDetails = null;
        let hasDescription = false;
        let isClickable = false;
        let hasError = (this.state.errors && this.state.errors.length >0);
        let descriptionValues = {};
        try {
            dataDetails = urlsConfiguration[ctx.kind].operations[ctx.operation].dataDetails;
            hasDescription = urlsConfiguration[ctx.kind].operations[ctx.operation].description;
            descriptionValues = urlsConfiguration[ctx.kind].operations[ctx.operation].descriptionValues;
            isClickable =  urlsConfiguration[ctx.kind].operations[ctx.operation].clickable;
        } catch (err) {

            hasError = true;
        }

        dataDetails = (dataDetails == null?true:dataDetails);

        let seriesTable = null;

        let description = null;
        let values={};
        if (!hasError && descriptionValues) {

            Object.keys(descriptionValues).forEach(function(key) {
                // Per costruire un nuovo oggetto con la stessa chiave bisogna che questa sia
                // racchiusa con parentesi quadrate.
                Object.assign(values, {[key]:formatMessage({id:descriptionValues[key]})});
            });

        }

        description = <FormattedHTMLMessage id={descriptionRef} values={values}/>;
        if (dataDetails) {

            if (this.state.series) {
                seriesTable = (
                    <Helpable bind="dataTable" guideRef="dataTable.guide">
                        <SeriesTable id="dataTable" ref="tableRef" key={'table-' + type}
                                     series={this.state.series} date={date}
                                     enabled={this.state.enabled}
                                     config={this.state.config}
                                     intl={this.props.intl}
                                     drillDown={currDepth}/>
                    </Helpable>
                );
            }
        }

        let hasData = (this.state.series && this.state.series[0].cols.length >0);


        return (
            <div className="row row-cards-pf" style={{paddingTop: "2px", paddingLeft: 0, paddingRight: 0 }}>
                <div className="col-md-12">

                    <h2 className="card-pf-title" style={{fontWeight: 300,
                        fontSize: '15pt',
                        marginTop:'0px'}}>
                        {this.props.cardTitle}
                    </h2>
                </div>



                <div className="col-md-12">
                    <div className="card-pf" style={{ paddingBottom: "5px", paddingTop: "5px" }}>
                        {this.props.children}
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="card-pf">

                        <BoxBody isLoading={this.state.isLoading}
                                 hasData={hasData}
                                 location={this.props.location}
                                 currentDrillDown={this.state.currentDrillDown}
                                 intl={this.props.intl}
                                 drilldownButtons={drillDownButtons}
                                 routeParams={this.props.routeParams}
                                 title={this.props.title}
                                 subtitle={boxSubtitle}
                                 description={description}
                                 paramContext={this.props.paramContext}
                                 exportHandler={this.exportHandler}
                                 resetFiltersHandler={this.resetFiltersHandler}
                                 toggleDetailsInfo={{
                                     handler: this.toggleDetailsHandler.bind(this),
                                     show:  this.state.hideGraph,
                                     dataDetails: dataDetails,
                                     hasDescription: hasDescription,
                                     isClickable: isClickable,
                                     dataTable: seriesTable
                                 }}

                                 optionsList={this.props.optionsList}>

                            { hasError?   <BoxError hasError={(this.state.errors && this.state.errors.length>0)} errors={this.state.errors || [{message:'Check Operation Params'}]}/>:
                                <Chart ref="outerChartRef" hide={this.state.hideGraph} config={this.state.config.config} handleDrillDown={this.drillDownHandler}  intl={this.props.intl}/>
                            }
                        </BoxBody>
                    </div>
                </div>
            </div>

        )
    }
}

ChartPanel.contextTypes = {
    router: PropTypes.object.isRequired
};

injectIntl(BoxError);
export default injectIntl(ChartPanel);



// WEBPACK FOOTER //
// ./src/components/ChartPanel/ChartPanel.js